import { render, staticRenderFns } from "./start-multiple.vue?vue&type=template&id=5b0f4672&scoped=true&"
import script from "./start-multiple.vue?vue&type=script&lang=js&"
export * from "./start-multiple.vue?vue&type=script&lang=js&"
import style0 from "./start-multiple.vue?vue&type=style&index=0&id=5b0f4672&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f4672",
  null
  
)

export default component.exports